/**
 * Concept Archetype
 *
 * @Version 1.0
 * @Author Daniel Lepe
 */

import _ from 'lodash'
import {getTimeSelectors} from './time-selectors'
import { store } from "@/store/store-init"

const baseController = 'alimentos',
    beginingLabel = 'Preparación',
    cookingLabel = 'En producción',
    packagingLabel = 'Abatimiento',
    finishedLabel = 'Finalizada';

const tabs = [
    beginingLabel,
    cookingLabel,
    packagingLabel,
    finishedLabel
];

const baseIndex = baseController + '/index'

const archetype = [
    // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id',
        type: 'hidden'
    },
    {
        key: 'pedido_id',
        type: 'hidden'
    },
    {
        key: 'usuario_id',
        type: 'hidden'
    },
    
    // ESTATUS Y USUARIO RESPONSABLE
    [
        {
            key: 'estatus',
            type: 'select',
            readonly: true,
            // default: beginingLabel,
            options: tabs
        },
        {
            key: 'usuario_id_responsable',
            label: 'Responsable de cocina',
            type: 'select',
            options: []
        }
    ],

    // RECETA Y PORCIONES
    [
        {
            key: 'encabezados_id',
            label: 'Receta',
            type: 'select',
            options: []
        },
        {
            key: 'porciones',
            type: 'positive'
        }
    ],

    // TITULO DE PREPARACIÓN
    [
        {
            key: 'titulo_preparacion',
            label: 'Título de preparación',
            type: 'textarea'
        }
    ],

    null,

    [
        {
            key: 'costo_total',
            label: 'Costo',
            type: 'number',
            readonly: true
        },
        {
            key: 'costo_unitario',
            label: 'Costo unitario',
            type: 'number',
            readonly: true
        },
    ],
    [
        {
            key: 'precio_total',
            label: 'Precio',
            type: 'number',
            readonly: true
        },
        {
            key: 'precio_unitario',
            label: 'Precio unitario',
            type: 'number',
            readonly: true
        }
    ],
    
    // CAMPOS ESCONDIDOS DE ALTA DE PEDIDO
    {
        key: 'pedido_fechaEntrega',
        type: 'hidden',
        label: 'Fecha entrega pedido'
    },
    {
        key: 'pedido_especificacionesPedido',
        label: 'Especificaciones pedido',
        type: 'hidden',
    },

    // CAMPOS ESCONDIDOS DE PRODUCCIÓN
    {
        key: 'imagen',
        type: 'hidden'
    },
    {
        key: 'duracion_preparacion_min',
        label: 'Preparación',
        type: 'hidden',
        default: 0,
        options: getTimeSelectors()
    },
    {
        key: 'duracion_coccion_min',
        label: 'Cocción',
        type: 'hidden',
        default: 0,
        options: getTimeSelectors()
    },
    {
        key: 'duracion_abatimiento_min',
        label: 'Abatimiento',
        type: 'hidden',
        default: 0,
        options: getTimeSelectors()
    },

    null,

    // CREATED
    [
        {
            key: 'created',
            readonly: true
        },
        {
            key: 'modified',
            readonly: true
        }
    ],

    // COMENTARIOS
    // [
        {
            key: 'comentarios',
            type: 'textarea',
            label: 'Comentarios'
        },
    // ],

    // ELEMENTOS DE SISTEMA
    {
        key: 'calculoInicial',
        type: 'hidden'
    },
    {
        key: 'devolucionesCFG',
        type: 'hidden',
        default: []
    },
    {
        key: 'elementosAbatimientoCFG',
        type: 'hidden',
        default: []
    },
    {
        key: 'inventarioVinculadoCFG',
        type: 'hidden',
        default: []
    },
]

const restHiddenCaptions = [
    'costo_total',
    'costo_unitario'
]

const captions = [
    // {key: 'imagen'},
    { key: 'id', label: 'ID' },
    { key: 'titulo_preparacion', label: 'Título de preparación'},
    { key: 'cocinero', label: 'Cocinero' },
    { key: 'estatus' },
    { key: 'folio', label: 'Folio de pedido' },
    { key: 'fechas'},
    { key: 'precio_total', label: 'Precio total' },
    { key: 'porciones' },
    { key: 'precio_unitario' },
    { key: '_' },
]

let automodalHandler = conceptId => {
    let str =
        baseController +
        '/' +
        'define' +
        (_.isNil(conceptId) ? '' : '/' + conceptId)
    return str
}

let restUIChanges = item2uichange => {
    switch(item2uichange.key){
        case 'usuario_id_responsable':
            item2uichange.default = store.getters.authGetUser.id_pk
            item2uichange.readonly = true
            break;
    }
    return item2uichange
}

let getArchetype = () => {
    let items2return = null;
	if(_.isPlainObject(store.getters.authGetUser)){
		switch(store.getters.authGetUser.tipoUsuario){
			case 'Admin':
				items2return = archetype;
				break;
			default:
				items2return = _.map(_.cloneDeep(archetype), item => {
                    if(_.isPlainObject(item)) {
                        return item;
                    } else if(_.isArray(item)){
                        return _.compact(_.map(item, subItem => {
                            if((restHiddenCaptions.indexOf(subItem.key) == -1)){
                                return restUIChanges(subItem);
                            }
                        }))
                    }
                });
				break;
		}
	}
	return items2return;
}

export {
    getArchetype,
    automodalHandler, 

    // VARS
    archetype,
    captions, 
    baseIndex, 

    // TABS LABEL
    beginingLabel,
    cookingLabel,
    packagingLabel,
    finishedLabel,

    // TABS CONFIG
    tabs
}
